<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="计划名称">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="dbColumn_productid" label="属于产品"></el-table-column>
				<el-table-column prop="dbColumn_publisher" width="90px" label="发布人"></el-table-column>
				<el-table-column prop="dbColumn_executor"  width="90px" label="执行人"></el-table-column>
				<el-table-column prop="createTime" width="160px" label="开始时间"></el-table-column>
				<el-table-column prop="endTime"  width="160px" label="结束时间"></el-table-column>
				<el-table-column prop="state" width="100px" label="状态">
					<template slot-scope="scope">
						<!-- 方式一：简单的 v-if 判断 -->
						<span v-if="scope.row.state === 1">新建</span>
						<span v-else-if="scope.row.state === 2">进行中</span>
						<span v-else-if="scope.row.state === 3">测试完成</span>
						<span v-else-if="scope.row.state === 4">bug修正中</span>
						<span v-else-if="scope.row.state === 5">结束</span>
						<span v-else>{{ scope.row.state }}</span> <!-- 兜底显示原值 -->
					</template>
				</el-table-column>
			
				<el-table-column label="操作" fixed="right" width="350px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="'00200025000'" size="mini" icon="el-icon-search"
								@click="toDetail(scope.$index, scope.row)">详情   </el-button>
							<el-button v-has-permission-code-and="'00200025000'" size="mini" icon="el-icon-edit"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button v-has-permission-code-and="'00200025000'" size="mini" icon="el-icon-edit"
								@click="allCase(scope.$index, scope.row)">用例</el-button>
							<el-button v-has-permission-code-and="'00200025000'" size="mini" icon="el-icon-delete"
								type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	      <show ref="show"></show>
		<caseEdit ref="caseEdit"></caseEdit>
	</div>
</template>
<script>

import edit from '@/views/product/testplan/edit.vue';
import show from '@/views/product/testplan/show.vue';
import caseEdit from '@/views/product/testplan/testcase/case.vue';

import api from '@/api/product/tst/testplan/testplan.js';


export default {
	name: 'testplan',
	components: {
		caseEdit,
		edit,show
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.listApi(params, response => {
				this.listData = response.data;
				this.listLoading = false;

			})

		
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加');
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.show.open(detailParameter, '详情', true);
		},
		allCase(index, row) {
		 
			this.$refs.caseEdit.open(row, '用例');
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.removeApi(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.removeApi({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.list()
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
